import { SortingDownwardsOutlined, SortingUpwardsOutlined } from '@icon';
import React from 'react';
import { useTheme } from 'styled-components';
import { ArrowSC } from './sort-arrow.styled';

interface SortArrowProps {
  isSorted: boolean;
  isSortedDesc?: boolean;
}

const SIZE = { width: 20, height: 20 };

const SortArrow: React.FunctionComponent<SortArrowProps> = ({ isSorted, isSortedDesc }) => {
  const theme = useTheme();

  if (isSorted && isSortedDesc) {
    return (
      <ArrowSC className="ui-table-sorter">
        <SortingDownwardsOutlined {...SIZE} />
      </ArrowSC>
    );
  }

  if (isSorted && !isSortedDesc) {
    return (
      <ArrowSC className="ui-table-sorter">
        <SortingUpwardsOutlined {...SIZE} />
      </ArrowSC>
    );
  }

  return (
    <ArrowSC className="ui-table-sorter">
      <SortingUpwardsOutlined color={theme.color.tint.tertiary} {...SIZE} />
    </ArrowSC>
  );
};

export default SortArrow;
